'use client';

import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import constants, {AmandemenType, SimplePayloadType, GroupedPerjanjianType} from '../../constants';
import moment from 'moment';



const initialState: AmandemenType = {
	verifiedIds: {
		capelID: null,
		kK0ID: null,
		formulirID: null,
	},
	listAmandemen: { ...constants.defaultResponse },
	formulirAmandemenData: {
		id: null,
		gasAvgUsagePlan: 0,
		gasAvgUsagePlanUnit: 'm³',
		penyebabAmandemen: '',
		pemberlakuanAmandemen: null,
		createdBy: '',
		docStatus: '',
		docNumber: '',
		modifiedBy: '',
		regionID: null,
		areaID: null,
		fullName: '',
		jabatan: '',
		namaPerusahaan: '',
		acC_ID: '',
		cusT_NUMBER: '',
		area: '',
		area_code: '',
		no_Telp: '',
		email: '',
		polaOperasiJamHari: 1,
		polaOperasiHariMinggu: 1,
		CurrentDate: '',
		position: '',
		produk: '',
		subProduk: '',
	},
	perjanjian: [
		{
			id: null,
			formulirID: '',
			perihal: '',
			perjanjianStart: null,
			perjanjianEnd: null,
			perjanjianPemakaianMaksimum: 0,
			usulanStart: null,
			usulanEnd: null,
			usulanPemakaianMaksimum: 0,
			keterangan: '',
			basisKontrak: '',
			perjanjian: '',
			produk: '',
			subProduk: '',
			perjanjianPemakaianMinimum: 0,
			usulanPemakaianMinimum: 0,
			perjanjianTekananOutlet: 0,
			usulanTekananOutlet: 0,
			usulanProduk: '',
			peralatanPenggunaGas: '',
			usulanPeralatanPenggunaGas: '',
			usulanSubProduk: '',
			isActive: 0,
			createdBy: '',
			modifiedBy: '',
			gasAvgUsagePlan: 0,
			gasAvgUsagePlanUnit: '',
			periodStartDate: moment().format('YYYY-MM-DD'),
			periodEndDate: moment().add(1, 'days').format('YYYY-MM-DD'),
		},
	],
	peralatan: [
		{
			id: null,
			formulirID: null,
			nama: '',
			jumlah: 0,
			kapasitas: 0,
			jamOperasi: 0,
			pemakaianMaksimum: 0,
			isActive: 0,
			// anomali used
			// penggunaanUnit: '',
			//new form mockup
			startDate: null,
			endDate: null,
			penggunaanGasRataRata: 0,
			unitGasRataRata: 'MMBTu',
			penggunaanGasMinimum: 0,
			unitGasMinimum: 'MMBTu',
			penggunaanGasMaksimum: 0,
			unitGasMaksimum: 'MMBTu',
			polaOperasiJamHari: '1',
			polaOperasiHariMinggu: '1',
			tekananOperasi: 0,
			// missing type
			amandemenID: null,
			createdBy: '',
			kapasitasUnit: '',
			createdOn: moment()
		},
	],
	groupedPerjanjian: [
		{
			periodStartDate: moment().format('YYYY-MM-DD'),
			periodEndDate: moment().add(1, 'days').format('YYYY-MM-DD'),
			data: [
				{
					id: null,
					formulirID: '',
					perihal: '',
					perjanjianStart: null,
					perjanjianEnd: null,
					perjanjianPemakaianMaksimum: 0,
					usulanStart: null,
					usulanEnd: null,
					usulanPemakaianMaksimum: 0,
					keterangan: '',
					basisKontrak: '',
					perjanjian: '',
					produk: '',
					subProduk: '',
					perjanjianPemakaianMinimum: 0,
					usulanPemakaianMinimum: 0,
					perjanjianTekananOutlet: 0,
					usulanTekananOutlet: 0,
					usulanProduk: '',
					peralatanPenggunaGas: '',
					usulanPeralatanPenggunaGas: '',
					usulanSubProduk: '',
					isActive: 0,
					createdBy: '',
					modifiedBy: '',
					gasAvgUsagePlan: 0,
					gasAvgUsagePlanUnit: '',
					periodStartDate: moment().format('YYYY-MM-DD'),
					periodEndDate: moment().add(1, 'days').format('YYYY-MM-DD'),
				}
			]
		}
	],
	validations: {
		valid: false,
		data: null,
		errors: {}
	}
};

export const amandemenData = createSlice({
	name: 'amandemenData',
	initialState,
	reducers: {
		addAmandemenList: (state, action) => {
			state.listAmandemen = action.payload;
		},
		changeFormulirAmandemen: (state, action) => {
			state.formulirAmandemenData = action.payload;
		},
		changeAmendment: (state, action) => {
			state.perjanjian = action.payload;
		},
		changeVerifiedIds: (state, action) => {
			state.verifiedIds = action.payload;
		},
		changeGroupedPerjanjian: (state, action) => {
			if (action.payload.field) {
				const { isSendAll, groupIndex, itemIndex, field, value } = action.payload;
				state.groupedPerjanjian[groupIndex!].data[itemIndex!][field] = value;
			} else if (action.payload.newItem) {
				state.groupedPerjanjian[action.payload.groupIndex].data.push(action.payload.newItem);
			} else if (action.payload.isRemove) {
				state.groupedPerjanjian[action.payload.groupIndex].data.splice(action.payload.itemIndex, 1);
			} else {
				state.groupedPerjanjian = action.payload;
			}
		},
		changeValidations: (state, action) => {
			state.validations = action.payload;
		},
	},
});

export const {
	addAmandemenList,
	changeAmendment,
	changeFormulirAmandemen,
	changeVerifiedIds,
	changeGroupedPerjanjian,
	changeValidations,
} = amandemenData.actions;

export default amandemenData.reducer;
